import PropTypes from "prop-types";
//Styles
import styled from "styled-components";
import theme from "../../../styles/theme.semantic";

const Section = styled.section`
  min-height: ${props => props.height || "auto"};
  padding-top: ${props => props.paddingTop};
  padding-bottom: ${props =>
    props.hasBottomSpacing ? props.paddingBottom : 0};

  background-color: ${props =>
    props.backgroundColor || props.theme.components.section.backgroundColor};
  position: ${props => props.position};
  width: ${props => props.width};
  bottom: ${props => props.bottom};
  position: ${props => props.position};
  border-top: ${props => props.borderTop};

  ${props =>
    props.verticalAlign ? "display: flex; align-items: center;" : null};

  // Large devices (desktops, less than 1200px)
  @media (max-width: 1199px) {
    border-top: ${props => props.lgBorderTop};
    padding-top: ${props => props.lgPaddingTop};
    padding-bottom: ${props => props.lgPaddingBottom};
  }

  // Medium devices (tablets, less than 992px)
  @media (max-width: 992px) {
    border-top: ${props => props.mdBorderTop};
    padding-bottom: ${props => props.mdPaddingBottom};
    padding-top: ${props => props.mdPaddingTop};

    min-height: ${props => props.mdHeight};
  }
`;

Section.propTypes = {
  height: PropTypes.string,
  paddingTop: PropTypes.string,
  paddingBottom: PropTypes.string,
  mdPaddingTop: PropTypes.string,
  mdPaddingBottom: PropTypes.string,
  lgPaddingTop: PropTypes.string,
  lgPaddingBottom: PropTypes.string,
  backgroundColor: PropTypes.string,
  verticalAlign: PropTypes.bool,
  hasBottomSpacing: PropTypes.bool
};

Section.defaultProps = {
  ...theme.components.section,
  height: "auto",
  verticalAlign: false,
  hasBottomSpacing: true
};

export default Section;
